/**
 * Default layout manager
 * It does nothing, keeping all nodes in their position.
 */

const doLayout = (nodeUI) => {};
const setPosition = () => {};
export default { doLayout, setPosition };
